export const branchImageActions = {
    VIEW_IMAGE: "VIEW_IMAGE",
    ATTACH_IMAGE: "ATTACH_IMAGE",
};
